export default __webpack_public_path__ + "static/media/cleanRoomStaticControl.a4c82a04.jpg";